module.exports = __webpack_public_path__ + "img/hero-image.af8b007e.svg";